import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';

// ── Types ─────────────────────────────────────────────────────

export interface Organization {
  id: string;
  name: string;
  logoUrl: string | null;
  defaultCurrency: string;
  defaultLanguage: string;
  timezone: string | null;
  referencePrefix: string;
  createdAt: string;
  updatedAt: string;
}

// ── Queries ───────────────────────────────────────────────────

export function useOrganization() {
  return useQuery({
    queryKey: ['organization'],
    queryFn: () => api.get<Organization>('/api/organizations/me'),
  });
}

// ── Mutations ─────────────────────────────────────────────────

export function useUpdateOrganization() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      name?: string;
      logoUrl?: string | null;
      defaultCurrency?: string;
      defaultLanguage?: string;
      timezone?: string;
      referencePrefix?: string;
    }) => api.put<Organization>('/api/organizations/me', params),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['organization'] }),
  });
}
